import { clientType, getClientType } from 'Environment/getClientType';
import { isCitrixChromeApp } from 'Environment/launchResource/device';

// This is a wrapper around getClientType to ensure that clientType is correctly returned for GACS in case of chrome app. Don't use this function for other purposes
// without checking behavior as it may trigger unexpected flow.
export function getClientTypeForGACS(): clientType {
	if (isCitrixChromeApp()) {
		return clientType.chromeapp;
	}
	return getClientType();
}
